import { Injectable, Query } from '@nestjs/common';
import { ZipperActivateDeactivateDto, ZipperResponseModel } from '@project-management-system/shared-models';
import { DataSource, Not } from 'typeorm';
import { ErrorResponse } from 'packages/libs/backend-utils/src/models/global-res-object';
import { SizehtMatrixEntity } from '../po-bom/entittes/size-ht-matrix-entity';
import { ZipperEntity } from './entity/zipper-entity';
import { ZipperBDto } from './dto/zipper-dto';
import { ZipperAdapter } from './adapter/zipper.adapter';
import { ZipperRepository } from './zipper-repo';

@Injectable()
export class ZipperService {
    constructor(
        private repo: ZipperRepository,
        private  adaptor: ZipperAdapter,

    ) { }
    async createZipper(req: ZipperBDto, isUpdate: boolean): Promise<ZipperResponseModel> {
        try {
            const existingCombination = await this.repo.findOne({
                where: {
                    style: req.style,
                    size: req.size,
                    ...(isUpdate && { id: Not(req.id) }),
                },
            });
    
            if (existingCombination) {
                return new ZipperResponseModel(false, 400, 'The same style and size combination already exists.');
            }
    
            const adapterData = this.adaptor.convertDtoToEntity(req);
    
            if (isUpdate) {
                const existingRecord = await this.repo.findOne({ where: { id: req.id } });
                if (existingRecord) {
                    adapterData.createdUser = existingRecord.createdUser;
                    adapterData.updatedUser = req.createdUser;
                }
            } else {
                adapterData.createdUser = req.createdUser;
            }
    
            await this.repo.save(adapterData);
    
            return new ZipperResponseModel(true, 200, isUpdate ? 'Updated Successfully' : 'Created Successfully');
        } catch (err) {
            throw err;
        }
    }
    
    async getData(): Promise<ZipperResponseModel> {
        let query = `select id , style , size , consumption , version_flag as versionFlag , is_active as isActive from zipper`
        const data = await this.repo.query(query)
      
        return new ZipperResponseModel(true, 1111, 'Data retreived', data)
    }

  


    async activateOrDeactivate(Req: ZipperActivateDeactivateDto): Promise<ZipperResponseModel> {
        try {
            const StyleExists = await this.getZipperById(Req.id);
            if (StyleExists) {
                if (Req.versionFlag !== StyleExists.versionFlag) {
                    throw new ZipperResponseModel(false,10113, 'Someone updated the current Zipper information.Refresh and try again');
                } else {

                    const zipperStatus = await this.repo.update(
                        { id: Req.id },
                        { isActive: Req.isActive, updatedUser: Req.updatedUser });

                    if (StyleExists.isActive) {
                        if (zipperStatus.affected) {
                            const response: ZipperResponseModel = new ZipperResponseModel(true, 10115, 'Zipper is Deactivated successfully');
                            return response;
                        } else {
                            throw new ZipperResponseModel(false,10111, 'Zipper is already deactivated');
                        }
                    } else {
                        if (zipperStatus.affected) {
                            const response: ZipperResponseModel = new ZipperResponseModel(true, 10114, 'Zipper is activated successfully');
                            return response;
                        } else {
                            throw new ZipperResponseModel(false,10112, 'Zipper is already activated');
                        }
                    }
                }
            } else {
                throw new ZipperResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }
    async getZipperById(id: number): Promise<ZipperEntity> {
        const Response = await this.repo.findOne({
            where: { id: id },
        });
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

}
